import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';
import { serializeSOEntryReportAttributes } from '../domains/so-orders/soEntryReportAttributes';

import '../contracts/Orders_ConfirmEntryReportInput';
import '../contracts/Orders_ConfirmEntryReportResponse';
import '../contracts/Orders_EntryReportResponse';
import type { Orders_ConfirmEntryReportInput } from '../contracts/Orders_ConfirmEntryReportInput';
/**
 * Composable for SO Entry Report operations.
 * Manages entry report photos, conditions, and confirmation.
 */
export function useSOEntryReports() {
  const isLoading = ref(false);
  const error = ref(null);
  const basePath = '/index.php/so/orders';

  const getEntryReport = async (orderItemId: number) => {
    log('useSOEntryReports', 'getEntryReport', 'Fetching entry report', { orderItemId });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/entry_report/${orderItemId}`, { responseContract: 'Orders_EntryReportResponse' });
      if (response.success) {
        return response.dados;
      }
      throw new Error(response.error || 'Erro ao buscar laudo de entrada');
    } catch (err) {
      logError('useSOEntryReports', 'getEntryReport', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const confirmEntryReport = async (orderItemId: any, attributes = []) => {
    const serialized = serializeSOEntryReportAttributes(attributes);
    const payload: Orders_ConfirmEntryReportInput = {
      order_item_id: orderItemId,
      attributes: serialized.map(a => ({ attribute_id: Number(a.attribute_id), value: a.value }))
    };
    log('useSOEntryReports', 'confirmEntryReport', 'Confirming entry report', { orderItemId, payload });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.put(`${basePath}/confirm_entry_report`, payload, { inputContract: 'Orders_ConfirmEntryReportInput', responseContract: 'Orders_ConfirmEntryReportResponse' });
      if (response.success) {
        return response;
      }
      throw new Error(response.error || 'Erro ao confirmar laudo de entrada');
    } catch (err) {
      logError('useSOEntryReports', 'confirmEntryReport', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };


  return {
    isLoading,
    error,
    getEntryReport,
    confirmEntryReport
  };
}
